export const isFetching = state => state.portal.groupManager.people.fetching;
export const people = state => state.portal.groupManager.people.people;
export const error = state => state.portal.groupManager.people.error;
export const member = (state, memberId) =>
  people(state).find(f => f.id === memberId) || {
    contact: {},
    assignments: []
  };
